
// Login.
export const GET = 'GET';
export const POST = 'POST';
export const PUT = 'PUT';
export const HEAD = 'HEAD';
export const DISABLE_MODAL_RETRIES = false;
export const ENABLE_MODAL_RETRIES = true;
export const ENABLE_HTTPS = true;
export const DISABLE_HTTPS = false;
export const ENABLE_400_AS_200 = true;
export const ENABLE_401_AS_200 = true;
export const ENABLE_402_AS_200 = false;
export const ENABLE_409_AS_200 = true;
export const ENABLE_422_AS_200 = true;
export const ENABLE_304_AS_200 = true;
export const ENABLE_403_AS_200 = false;

export const ENABLE_429_AS_200 = true;
export const ENABLE_404_AS_200 = false;
export const ENABLE_500_AS_200 = false;
export const ENABLE_501_AS_200 = false;

export const CONTENT_TYPE_TEXT_HTML = 'text/html';
export const CONTENT_TYPE_TEXT_PLAIN = 'text/plain';
export const CONTENT_TYPE_TEXT_JSON = 'text/json';
export const CONTENT_TYPE_APPLICATION_OCTET_STREAM = 'application/octet-stream';
export const CONTENT_TYPE_TEXT_VTT = 'text/vtt';
export const CONTENT_TYPE_APP_JSON = 'application/json';
export const CONTENT_TYPE_TEXT_XML = 'text/xml';
export const CONTENT_TYPE_APP_XML = 'application/xml';
export const CONTENT_TYPE_TEXT_DASH_XML = 'application/dash+xml';
export const CONTENT_ESTATUS_200 = 200;
export const RETRIES_CLARO_PAGOS = 0;
export const APIVERSION = 'v5.94';
export const URLRECORDINGLIST = 'recordings/series/list';



// WEBPACK FOOTER //
// ./src/requests/RequestManagerConstants.js